import './target-selection-visio.ajscss';

import { TransferTarget } from '@agent/core/contact/transfer/models/transfer';
import { hasChange } from '@commons/util/helper/helper';
import { copy, IChangesObject, IComponentController, IComponentOptions } from 'angular';
import { i18n } from 'i18next';

import templateUrl from './target-selection-visio.html';

const MODULE_NAME = 'transferTargetSelectionVisio';

class TransferTargetSelectionVisioCtrl implements IComponentController {
  public name = MODULE_NAME;

  // binding
  public eventTargetTypeChange: Function;
  public targetType: TransferTarget;

  // internal properties
  public targetTypes: TransferTarget[] = [];

  constructor(private readonly $i18next: i18n) {}

  $onInit() {
    // target available to transfer
    this.targetTypes.push(TransferTarget.SKILL);
    this.targetTypes.push(TransferTarget.AGENT);
    // initialize target type to first value of types available
    if (!!this.targetType) {
      this.targetType = this.targetTypes[0];
    }
    this.onTargetTypeChange();
  }

  $onChanges(changesObj: { [property: string]: IChangesObject }) {
    // targetType changed
    if (hasChange(changesObj['targetType'])) {
      this.targetType = copy(changesObj['targetType'].currentValue);
    }
  }

  onTargetTypeChange(): void {
    this.eventTargetTypeChange({ $event: { targetType: this.targetType } });
  }

  getTargetLabel(target: TransferTarget): string {
    let targetKey = TransferTarget[target].toLowerCase();
    return this.$i18next.t('agent:contact.workspace.transfer.target_selection.' + 'mail' + '.' + targetKey); // TODO improve media selector
  }
}

export class TransferTargetSelectionVisio implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    targetType: '<',
    eventTargetTypeChange: '&',
  };
  controller = ['$i18next', TransferTargetSelectionVisioCtrl];
}

export default MODULE_NAME;
